import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { WebserviceProjectResponse } from './get-webservice-project';

export function postUploadWebserviceImage(
    file: File,
    fileName: string,
    project: string,
): Promise<WebserviceProjectResponse['images'][number]> {
    const { apiPostUploadWebserviceImage } = apiConfig.getStaticUrls();
    const secretKey = apiConfig.getSecretKey();
    const postData = new FormData();
    postData.append('file', file, fileName);
    postData.append('sk', secretKey);
    postData.append('project', project);
    return postFetch(apiPostUploadWebserviceImage, postData);
}
